const _excluded = ["icon", "className", "iconClassName", "active", "color", "filled", "count", "emoji", "text"];
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/status-action-button.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
import { Text, Icon, EmojiReact, Emoji } from 'soapbox/components/ui';
import { shortNumberFormat } from 'soapbox/utils/numbers';
const COLORS = {
  accent: 'accent',
  success: 'success',
  yellow: 'yellow'
};
/** Action button numerical counter, eg "5" likes. */
const StatusActionCounter = ({
  count = 0
}) => {
  return /*#__PURE__*/React.createElement(Text, {
    size: "xs",
    weight: "semibold",
    theme: "inherit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 5
    }
  }, shortNumberFormat(count));
};
const StatusActionButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      icon,
      className,
      iconClassName,
      active,
      color,
      filled = false,
      count = 0,
      emoji,
      text
    } = props,
    filteredProps = _objectWithoutProperties(props, _excluded);
  const renderIcon = () => {
    if (emoji) {
      return /*#__PURE__*/React.createElement("span", {
        className: "block w-6 h-6 flex items-center justify-center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46,
          columnNumber: 9
        }
      }, typeof emoji === 'string' ? /*#__PURE__*/React.createElement(Emoji, {
        className: "w-full h-full p-0.5",
        emoji: emoji,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48,
          columnNumber: 13
        }
      }) : /*#__PURE__*/React.createElement(EmojiReact, {
        className: "w-full h-full p-0.5",
        emoji: emoji,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 13
        }
      }));
    } else {
      return /*#__PURE__*/React.createElement(Icon, {
        src: icon,
        className: classNames({
          'fill-accent-300 hover:fill-accent-300': active && filled && color === COLORS.accent
        }, iconClassName),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56,
          columnNumber: 9
        }
      });
    }
  };
  const renderText = () => {
    if (text) {
      return /*#__PURE__*/React.createElement(Text, {
        tag: "span",
        theme: "inherit",
        size: "sm",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 9
        }
      }, text);
    } else if (count) {
      return /*#__PURE__*/React.createElement(StatusActionCounter, {
        count: count,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 78,
          columnNumber: 9
        }
      });
    }
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    type: "button",
    className: classNames('flex items-center p-1 rounded-full', 'text-gray-600 hover:text-gray-600 dark:hover:text-white', 'bg-white dark:bg-transparent', 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:ring-offset-0', {
      'text-black dark:text-white': active && emoji,
      'text-accent-300 hover:text-accent-300 dark:hover:text-accent-300': active && !emoji && color === COLORS.accent,
      'text-success-600 hover:text-success-600 dark:hover:text-success-600': active && !emoji && color === COLORS.success,
      'text-yellow-600 hover:text-yellow-600 dark:hover:text-yellow-600': active && !emoji && color === COLORS.yellow,
      'space-x-0.5': !text,
      'space-x-2': text
    }, className)
  }, filteredProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 5
    }
  }), renderIcon(), renderText());
});
export default StatusActionButton;